import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import { reducer as formReducer } from "redux-form";
import reduxThunk from "redux-thunk";

import absenceReducer from "./reducers/absenceReducer";
import accessCodeReducer from "./reducers/accessCodeReducer";
import authReducer from "./reducers/authReducer";
import canteenReportReducer from "./reducers/canteenReportReducer";
import errorReducer from "./reducers/errorReducer";
import externalUnitReducer from "./reducers/externalUnitReducer";
import formsReducer from "./reducers/formsReducer";
import mealReducer from "./reducers/mealReducer";
import mealOrderReducer from "./reducers/mealOrderReducers";
import mealReservationReducer from "./reducers/mealReservationReducer";
import menuReducer from "./reducers/menuReducer";
import occasionsReducer from "./reducers/occasionsReducer";
import paycheckReducer from "./reducers/paycheckReducer";
import requestReducer from "./reducers/requestReducer";
import settingsReducer from "./reducers/settingsReducer";
import structureReducer from "./reducers/structureReducer";
import userReducer from "./reducers/userReducer";
import workingTimeReducer from "./reducers/workingTimeReducer"

const reducers = combineReducers({
    absence: absenceReducer,
    accessCode: accessCodeReducer,
    auth: authReducer,
    canteenReport: canteenReportReducer,
    error: errorReducer,
    externalUnit: externalUnitReducer,
    forms: formsReducer,
    meal: mealReducer,
    mealOrder: mealOrderReducer,
    mealReservation: mealReservationReducer,
    menu: menuReducer,
    occasions: occasionsReducer,
    paycheck: paycheckReducer,
    request: requestReducer,
    settings: settingsReducer,
    structure: structureReducer,
    user: userReducer,
    workingTime: workingTimeReducer,
    form: formReducer
});

const composeEnhancers = compose;
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));

export default store;